
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("list/tasklist-empty-cleared",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexcenter class=\"flexauto flexcol\" style=\"max-width: 280px;margin: auto;text-align:center;flex:1\"><img src=\"/images/ic_empty_list_cleared.svg\" width=\"120\" height=\"120\"/><h2>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.emptyclearedtitle",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":175},"end":{"line":1,"column":215}}})) != null ? stack1 : "")
    + "</h2><p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"catsystem.emptycleared",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":223},"end":{"line":1,"column":258}}})) != null ? stack1 : "")
    + "</p></flexcenter>";
},"useData":true});
export default TPL;